import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import { Duplicate, LinkTo } from "@dreamhub/designsystem/icons";

interface SourceContractBannerProps {
  sourceContractId: string;
  sourceContractName: string;
}

const SourceContractBanner: React.FC<SourceContractBannerProps> = ({
  sourceContractId,
  sourceContractName
}) => {
  const { t } = useTranslation();

  return (
    <div
      className="flex items-center justify-center gap-2 w-full shrink-0 bg-purple-opacity border-b border-purple-opacity px-4 py-2"
      data-test="duplicate-source-banner"
    >
      <IconContainer size="5">
        <Duplicate />
      </IconContainer>
      <Text variant="body">{t("contracts.duplicate.copyOf")}</Text>
      <Link
        to={`/contracts/${sourceContractId}`}
        data-test="duplicate-source-banner-link"
      >
        <span className="flex items-center gap-1">
          <IconContainer size="sm" color="link">
            <LinkTo />
          </IconContainer>
          <Text variant="body" className="text-link">
            {sourceContractName}
          </Text>
        </span>
      </Link>
    </div>
  );
};

export default SourceContractBanner;
